// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CcmListItem-Template img, .CcmListItem-Template.CcmListImage {
  border-radius: 5px;
}

.fi-document-template-list-view .ListContainer {
  position: relative;
}
.fi-document-template-list-view .ListContainer .fi-items-list-actions {
  position: absolute;
  z-index: 1;
  top: 20px;
}`, "",{"version":3,"sources":["webpack://./Source/app/document-template/document-template-list-view/document-template-list-view.component.scss","webpack://./Source/app/shared/fi-shared-styles/fi-items-list-absolute.scss"],"names":[],"mappings":"AAGI;EAEI,kBAAA;AAHR;;AAQI;EACI,kBAAA;AALR;ACLI;EACI,kBAAA;EACA,UAAA;EACA,SDQ2D;AADnE","sourcesContent":["@use '../../shared/fi-shared-styles/fi-items-list-absolute';\r\n\r\n.CcmListItem-Template {\r\n    img,\r\n    &.CcmListImage {\r\n        border-radius: 5px;\r\n    }\r\n}\r\n\r\n.fi-document-template-list-view {\r\n    .ListContainer {\r\n        position: relative;\r\n        @include fi-items-list-absolute.fi-items-list-absolute-top(20px);\r\n    }\r\n}\r\n","@mixin fi-items-list-absolute-top($topOffset) {\r\n    .fi-items-list-actions {\r\n        position: absolute;\r\n        z-index: 1;\r\n        top: $topOffset;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
